import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	CreateEstimateButton,
	DesignPacketFiles,
	ExitButton,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderCommunicationButton,
	RetailOrderDatesPanel,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	SubmitDesignButton
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';
import { FileTypes } from '../../../types/enums';

export default function UploadDesignPage() {

	return (
		<RetailOrderPage>

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<SubmitDesignButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderFilesButton defaultFileType={FileTypes.CabinetDesignPacket} />
						</ToolbarItem>
						<ToolbarItem>
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>
					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>

			<Box>
				<Item ratio={1}>
					<RetailOrderDatesPanel
						showScheduledInstallDates={false}
						showInvoiceDate={false}
						editCabinetDates={false}
					/>
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<DesignPacketFiles />

			<RetailOrderProducts />

		</RetailOrderPage>
	)
}
